// extracted by mini-css-extract-plugin
export default {"root":"yMwUr","notice":"Ilow7","icon":"MfiTo"};